import { render } from "./RevisarSolicitudesDosis.vue?vue&type=template&id=94373038"
import script from "./RevisarSolicitudesDosis.vue?vue&type=script&lang=js"
export * from "./RevisarSolicitudesDosis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__